/** Hover text for a ledger mailedOn value, for example 11/2/26. */
function formatMailedOnTitle(value) {
  const iso = mailedOnIsoDate(value);
  if (!iso) return '';
  const [year, month, day] = iso.split('-');
  return `${Number(month)}/${Number(day)}/${year.slice(2)}`;
}

/** YYYY-MM-DD or null. Accepts a date-only string or an ISO datetime prefix. */
function mailedOnIsoDate(value) {
  const text = String(value ?? '').trim().slice(0, 10);
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }
  return text;
}

module.exports = {
  formatMailedOnTitle,
  mailedOnIsoDate,
};
